import Papa from 'papaparse';

/**
 * Parses a CSV file and returns parsed data
 * @param {File} file - The CSV file to parse
 * @param {Object} options - Parsing options
 * @param {Function} options.onComplete - Callback function called when parsing is complete
 * @param {Function} options.onError - Callback function called when parsing fails
 * @param {Object} options.fieldMapping - Optional field mapping for different CSV structures
 */
export const parseCSV = (file, { onComplete, onError, fieldMapping = null }) => {
    if (!file) {
        if (onError) {
            onError(new Error('No file provided'));
        }
        return;
    }

    Papa.parse(file, {
        header: true, // Assumes the CSV file has headers
        skipEmptyLines: true,
        complete: (result) => {
            if (onComplete) {
                onComplete(result.data);
            }
        },
        error: (error) => {
            console.error("Error parsing the CSV file:", error);
            if (onError) {
                onError(error);
            }
        }
    });
};

/**
 * Parses CSV data for competitors
 * @param {Array} csvData - Parsed CSV data array
 * @returns {Array} Array of competitor objects
 */
export const parseCompetitorCSV = (csvData) => {
    const competitors = [];
    for (let i = 0; i < csvData.length; i++) {
        const firstname = csvData[i].firstname || '';
        const lastname = csvData[i].lastname || '';
        const gender = csvData[i].gender || '';
        const tag_number = csvData[i].tag_number || '';
        const email = csvData[i].email;
        const age = csvData[i].age || 0;
        competitors.push({ firstname, lastname, gender, email, age, tag_number });
    }
    return competitors;
};

/**
 * Parses CSV data for adjudicators
 * @param {Array} csvData - Parsed CSV data array
 * @returns {Array} Array of adjudicator objects
 */
export const parseAdjudicatorCSV = (csvData) => {
    const adjudicators = [];
    for (let i = 0; i < csvData.length; i++) {
        const email = csvData[i].email;
        const firstname = csvData[i].firstname || '';
        const lastname = csvData[i].lastname || '';
        if (email) {
            adjudicators.push({ email, firstname, lastname });
        }
    }
    return adjudicators;
};

